import { RouteRecordRaw } from "vue-router"

const adminRoutesForKs: RouteRecordRaw[] = [
    {
        path: "/company-management",
        name: "company-management",
        meta: {
            title: "公司管理",
            icon: "OfficeBuilding"
        },
        redirect: "/company-management",
        component: () => import("@/layouts/index.vue"),
        children: [
            {
                path: "company-list",
                name: "company-list",
                meta: {
                    title: "公司列表",
                    hidden: true
                },
                component: () => import("@/views/CompanyManagement/CompanyList/index.vue")
            },
            {
                path: "business-overview",
                name: "business-overview",
                meta: {
                    title: "经营概览",
                    hidden: true
                },
                redirect: "/company-management/business-overview/tik-tok-business-overview",
                children: [
                    {
                        path: "tik-tok-business-overview",
                        name: "tik-tok-business-overview",
                        meta: {
                            title: "抖音经营概览"
                        },
                        component: () => import("@/views/CompanyManagement/BusinessOverview/TikTok/index.vue")
                    },
                    {
                        path: "ks-business-overview",
                        name: "ks-business-overview",
                        meta: {
                            title: "快手经营概览"
                        },
                        component: () => import("@/views/CompanyManagement/BusinessOverview/KS/index.vue")
                    }
                ]
            },
            // 后面加的
            {
                path: "tik-tok-business-overview-v2",
                name: "tik-tok-business-overview-v2",
                meta: {
                    title: "抖音经营概览",
                    hidden: true
                },
                component: () => import("@/views/CompanyManagement/BusinessOverview/TikTok/index.vue")
            },
            {
                path: "tik-tok-company-promotion-list",
                name: "tik-tok-company-promotion-list",
                meta: {
                    title: "抖音推广列表",
                    hidden: true
                },
                component: () => import("@/views/CompanyManagement/promotionListV2/TikTok/index.vue")
            },
            {
                path: "order-details",
                name: "order-details",
                meta: {
                    title: "订单明细",
                    hidden: true
                },
                component: () => import("@/views/CompanyManagement/OrderDetails/index.vue")
            },
            {
                path: "business-center",
                name: "business-center",
                component: () => import("@/views/CompanyManagement/BusinessCenter/index.vue"),
                meta: {
                    title: "工单中心",
                    hidden: true
                }
            },
            {
                path: "dp-business",
                name: "dp-business",
                meta: {
                    title: "DP运营",
                    hidden: true
                },
                redirect: "/company-management/dp-business/dp-data-detail",
                children: [
                    {
                        path: "dp-data-detail",
                        name: "dp-data-detail",
                        meta: {
                            title: "运营数据详情"
                        },
                        component: () => import("@/views/CompanyManagement/DpBusiness/DataDetail/index.vue")
                    },
                    {
                        path: "dp-amount-settlement",
                        name: "dp-amount-settlement",
                        meta: {
                            title: "运营员工结算"
                        },
                        component: () => import("@/views/CompanyManagement/DpBusiness/AmountSettlement/index.vue")
                    }
                ]
            },
            {
                path: "talent-management",
                name: "talent-management",
                component: () => import("@/views/CompanyManagement/TalentManagement/index.vue"),
                meta: {
                    title: "达人管理",
                    hidden: true
                },
            },
            {
                path: "employee-group-center",
                name: "employee-group-center",
                meta: {
                    title: "员工榜单分组"
                },
                redirect: "/company-management/employee-group-center/tiktok-employee-group-center",
                children: [
                    // hidden属性无法控制，直接注释掉
                    /*{
                        path: "tiktok-employee-group-center",
                        name: "tiktok-employee-group-center",
                        meta: {
                            title: "抖音员工榜单分组",
                            hidden: true
                        },
                        component: () => import("@/views/CompanyManagement/EmployeeGroupCenter/TikTokEmployeeGroupCenter/index.vue")
                    },*/
                    {
                        path: "ks-employee-group-center",
                        name: "ks-employee-group-center",
                        meta: {
                            title: "快手员工榜单分组"
                        },
                        component: () => import("@/views/CompanyManagement/EmployeeGroupCenter/KsEmployeeGroupCenter/index.vue")
                    },
                    {
                        path: "wechat-employee-group-center",
                        name: "wechat-employee-group-center",
                        meta: {
                            title: "视频号员工榜单分组"
                        },
                        component: () => import("@/views/CompanyManagement/EmployeeGroupCenter/WeChatEmployeeGroupCenter/index.vue")
                    }
                ]
            }
        ]
    }
]

export default adminRoutesForKs
